export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/reforestacion.jpg',
	   "funcion": 'Jornada Nacional de Reforestación .',
		"url" : 'https://www.facebook.com/reel/963129466745173',
	},




	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/sesenta.jpg',
	    "funcion": '60 segundos.',
		"url" : 'https://www.facebook.com/reel/2399999873859645',
	},



		{
		"nombre": "Noticias.",
		"imagen": 'noticias/requisitos.jpg',
	    "funcion": 'El Podcast del Pueblo.',
		"url" : 'https://www.facebook.com/share/p/1JVZaA6sne/',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/buzón.jpg',
		"funcion": "Buzón Digital",
		"url": "https://buzondigitalcontraloria.hidalgo.gob.mx/"
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]